import { View } from "ui/atoms/view";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { Accordion } from "ui/gluestack/accordion";
import { BodyMapEntryItem } from "../../../features/reporting/organisms/BodyMapEntryItem";
import { NoItemsComponent } from "ui/atoms/noItems";
import { useGetBodyMapEntries } from "../../../features/reporting/hooks/useGetBodyMapEntries";
import { BodyMapEntryStatusEnums } from "../../../services/api/types/bodyMap/BodyMapEntryStatusEnums";
import Pagination from "ui/molecules/pagination/Pagination";
import { useState } from "react";

export function ResolvedBodyMapEntriesScreen() {
  const [openItemId, setOpenItemId] = useState<string | undefined>();

  const { data, isLoading, handlePageChange } = useGetBodyMapEntries({
    entryStatus: BodyMapEntryStatusEnums.RESOLVED,
  });

  return (
    <View className="resident-container">
      <View className="flex-column gap-3">
        {isLoading ? (
          <LoadingSpinner />
        ) : data?.data.length ? (
          <View>
            <Accordion
              type="single"
              variant="unfilled"
              className="mb-4 w-full"
              value={openItemId ? [openItemId] : []}
              onValueChange={(values) => {
                setOpenItemId(values[0]);
              }}
            >
              {data?.data.map((entry) => (
                <View key={entry.id} className="mb-3">
                  <BodyMapEntryItem
                    entry={entry}
                    isOpen={openItemId === entry.id.toString()}
                  />
                </View>
              ))}
            </Accordion>
          </View>
        ) : (
          <NoItemsComponent
            className="py-5"
            title="No Resolved Items"
            subtitle="There are no resolved body map entries for this resident."
          />
        )}
        <Pagination meta={data?.meta} onPageChange={handlePageChange} />
      </View>
    </View>
  );
}
